import React from "react";
import Navigation from "./Navigation";

export default function DocsSidebar({
  expandedSections,
  toggleSection,
  activeSection,
  setActiveSection,
  sidebarOpen,
  setSidebarOpen,
}) {
  const SidebarContent = (
    <div className="pt-3 pb-5 h-full overflow-y-auto scrollbar-thin scrollbar-thumb-gray-200 flex flex-col">
      <div className="px-4 pb-3 font-semibold text-lg text-[#01CC54] tracking-tight select-none">
        Documentation
      </div>
      <nav className="flex-1 px-3 space-y-1.5">
        <Navigation
          expandedSections={expandedSections}
          toggleSection={toggleSection}
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />
      </nav>
    </div>
  );

  return (
    <>
      {/* Desktop: fixed sidebar */}
      <aside
        className="
          hidden md:flex
          fixed top-0 left-0 h-full z-30
          bg-white shadow-lg border-r border-gray-200
          w-56 transition-all duration-200 text-gray-900
        "
        aria-label="Documentation sidebar"
      >
        {SidebarContent}
      </aside>

      {/* Mobile: overlay + slide-in */}
      {sidebarOpen && (
        <>
          {/* Overlay */}
          <button
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 md:hidden"
            aria-label="Close sidebar overlay"
            onClick={() => setSidebarOpen(false)}
          />
          {/* Drawer */}
          <div
            className="fixed top-0 left-0 h-full w-56 bg-white shadow-lg z-50 transition-transform duration-300 md:hidden border-r border-gray-200 text-gray-900"
            style={{ transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)" }}
            aria-label="Documentation drawer"
          >
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded p-1"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close sidebar"
            >
              ✕
            </button>
            {SidebarContent}
          </div>
        </>
      )}
    </>
  );
}
